import logUtil from 'utils/log'
import { UNLOCKED_EXTRA_FREE_SAMPLES_COUNT_TIER } from 'modules/cart/constants'
import { getSpendMoreToUnlockExtraFreeSamplesModalAt } from 'modules/cart/utils/update-spend-more-to-unlock-extra-free-samples-modal-shown-at'

/**
 * @param hasUnlockedExtraFreeSamplesCount
 * @param extraFreeSamplesTier
 * @param hasShownSpendMoreToUnlockExtraFreeSamplesModal
 * @param isCartReady
 * @param isSelectFreeBonusDeluxeSamplesStep
 * @param shouldShowMinimumToCheckOut
 * @param shouldShowMinimumToCheckOutBanner
 * @param shouldIgnoreMinimumToCheckout
 * @returns {boolean}
 */
export const shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelectorUtil = ({
  hasUnlockedExtraFreeSamplesCount,
  extraFreeSamplesTier,
  hasShownSpendMoreToUnlockExtraFreeSamplesModal,
  isCartReady,
  isSelectFreeBonusDeluxeSamplesStep,
  shouldShowMinimumToCheckOutBanner,
  shouldIgnoreMinimumToCheckout
}) => {
  if (
    !shouldIgnoreMinimumToCheckout &&
    shouldShowMinimumToCheckOutBanner
  ) {
    logUtil('shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelectorUtil').debug('[noop] shouldShowMinimumToCheckOutBanner=true')
    return false
  }

  if (isSelectFreeBonusDeluxeSamplesStep) {
    logUtil('shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelectorUtil').debug('[noop] selecting free bonus deluxe samples')
    return false
  }

  if (!isCartReady) {
    logUtil('shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelectorUtil').debug('[noop] cart not ready')
    return false
  }

  const hasShownSpendMoreToUnlockExtraFreeSamplesModalToUse = (
    hasShownSpendMoreToUnlockExtraFreeSamplesModal ||
    !!getSpendMoreToUnlockExtraFreeSamplesModalAt()
  )

  if (!hasShownSpendMoreToUnlockExtraFreeSamplesModalToUse) {
    logUtil('shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelectorUtil').debug('[noop] modal not shown')
    return false
  }

  const shouldShow = (
    hasUnlockedExtraFreeSamplesCount &&
    extraFreeSamplesTier !== UNLOCKED_EXTRA_FREE_SAMPLES_COUNT_TIER.ABOVE_249
  )

  const debugProps = {
    hasUnlockedExtraFreeSamplesCount,
    extraFreeSamplesTier,
    shouldShow
  }
  logUtil('shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelectorUtil').debug('[start] debugProps=', debugProps)

  return shouldShow
}
